import { useMutation } from '@tanstack/react-query';
import { post } from '@/shared/api/api-client';
import type { CancelAppointmentCommand } from '@/types/scheduling-api';

export function useCancelAppointment() {
  return useMutation({
    mutationFn: (command: CancelAppointmentCommand) =>
      post<void>('/api/Appointment/Cancel', command),
  });
}
